import React from 'react'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { v4 as uuidv4 } from "uuid";

const Faq = () => {

  const webDevelopmentFAQs = [
    {
      "id": uuidv4(),
      "question": "What is web development?",
      "answer": "Web development refers to the process of creating and maintaining websites or web applications. It involves various tasks such as web design, coding, content creation, and server-side scripting."
    },
    {
      "id": uuidv4(),
      "question": "What are the key technologies used in web development?",
      "answer": "Key technologies in web development include HTML, CSS, and JavaScript for front-end development, while back-end development often involves languages like Python, Ruby, PHP, or Java. Frameworks like React, Angular, and Vue.js are popular for front-end, and Node.js, Django, and Ruby on Rails for back-end."
    },
    {
      "id": uuidv4(),
      "question": "What is the difference between front-end and back-end development?",
      "answer": "Front-end development deals with the user interface and user experience of a website or web application. Back-end development involves server-side scripting, databases, and handling server requests. Both work together to create a functional and user-friendly web application."
    },
    {
      "id": uuidv4(),
      "question": "What is responsive web design?",
      "answer": "Responsive web design is an approach to design and development that ensures a website or application adapts to different screen sizes and devices. It aims to provide an optimal viewing experience, easy navigation, and readability across a wide range of devices, from desktop monitors to smartphones."
    },
    {
      "id": uuidv4(),
      "question": "How can I secure a website against common cyber threats?",
      "answer": "Securing a website involves practices like using HTTPS, validating user input, implementing proper authentication and authorization mechanisms, keeping software and plugins updated, and regularly performing security audits. It's crucial to stay informed about the latest security threats and best practices in web development."
    },
    {
      "id": uuidv4(),
      "question": "Is it worth paying someone to build a website?",
      "answer": "Investing in a professional to build your website is worth it because they bring expertise, save you time, offer customization, provide technical support, enhance your professional image, and optimize for search engines (SEO), leading to long-term benefits for your business."
    },
    {
      "id": uuidv4(),
      "question": "What features are essential for an ecommerce website?",
      "answer": "Essential features include a user-friendly interface, product catalog, secure payment gateway, shopping cart functionality, order management system, and customer account management."
    },
    {
      "id": uuidv4(),
      "question": "How can I optimize my ecommerce website for better conversion rates?",
      "answer": "To optimize for conversion rates, focus on clear product descriptions, high-quality images, easy navigation, streamlined checkout process, customer reviews, and responsive design."
    },
    {
      "id": uuidv4(),
      "question": "What factors should I consider before developing a mobile app?",
      "answer": "Factors to consider include defining your target audience, identifying the app's purpose and features, choosing the right platform (iOS, Android, or both), and planning for ongoing maintenance and updates."
    },
    {
      "id": uuidv4(),
      "question": "How do you ensure the security of a website during development?",
      "answer": "We implement security best practices such as using secure coding techniques, regular security updates, and employing SSL certificates for data encryption."
    },
    {
      "id": uuidv4(),
      "question": "Do I need a website development agency?",
      "answer": "Absolutely, hiring a website development agency can be highly advantageous. They bring expertise, professionalism, and a wealth of resources to the table, ensuring that your website is not only visually appealing but also functional and user-friendly. With their support, you can expect a high-quality website that effectively represents your brand and helps you achieve your online goals."
    },
    {
      "id": uuidv4(),
      "question": "Is it worth getting into ecommerce for beginners?",
      "answer": "Absolutely! Getting into e-commerce as a beginner can be incredibly rewarding. It offers a low barrier to entry, allowing you to start a business with minimal overhead costs compared to traditional brick-and-mortar stores. E-commerce provides the opportunity to reach a global audience, giving you the flexibility to scale your business at your own pace. With the right strategies and dedication, beginners can tap into the vast potential of e-commerce to build a successful and profitable venture."
    }
  ]
  return (
    <div className='px-5 sm:px-60 mt-10' id="faq">
      <p className='text-center font-notosans text-2xl sm:text-4xl font-bold m-10 text-[#333e49]'>Frequently Asked Questions</p>
      {
        webDevelopmentFAQs.map((item) => 
    <Accordion key={item.id}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        className='font-notosans font-bold'
      >
        {item.question}
      </AccordionSummary>
      <AccordionDetails className='font-notosans'>
        {item.answer}
      </AccordionDetails>
    </Accordion>
        )
      }
  </div>
  )
}

export default Faq